import { FunctionComponent, useEffect, useState } from 'react'

import { MdPlayArrow, MdSearch, MdCheck } from 'react-icons/md'
import { Grid } from '@material-ui/core'

import Autocomplete from 'shared/components/Autocomplete'
import Scaffold from 'shared/components/ScaffoldNew'
import Text from 'shared/components/Text'
import useDebounce from 'shared/hooks/useDebounce'
import { colors } from 'shared/styles/colors'
import { registerEvent } from 'shared/services/TrackingGAService'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import { Value } from 'shared/components/ModalSelectFrotista/styles'
import { useCaminhao } from 'modules/caminhao/hooks/useCaminhao'
import Veiculo from 'modules/veiculos/domain/entities/Veiculo'
import { IListVeiculosImpl } from 'modules/veiculos/domain/usecases/ListVeiculosImpl'

type TProps = {
  listVeiculos: IListVeiculosImpl
}

const TruckPlate: FunctionComponent<TProps> = ({ listVeiculos }) => {
  const {
    carreta1,
    carreta2,
    carreta3,
    setCarreta1,
    setCarreta2,
    setCarreta3,
    placaCarreta1Input,
    setPlacaCarreta1Input,
    placaCarreta2Input,
    setPlacaCarreta2Input,
    placaCarreta3Input,
    setPlacaCarreta3Input,
    tipoCaminhao,
    handleBackButton,
    indiceCarreta,
    setIndiceCarreta,
    handleCreateCaminhao,
    nomeCaminhao,
    veiculo,
    handleNextButton,
    setErrorMessage,
    setError,
    loading,
    setLoading,
  } = useCaminhao()
  const { frotistaId, frotista } = useFrotista()
  const [placaInput, setPlacaInput] = useState('')
  const [veiculosList, setVeiculoList] = useState<Veiculo[]>([])
  const [isFormOk, setIsFormOk] = useState(false)
  const [isTheEndOfCreate, setIsTheEndOfCreate] = useState(false)
  const [loadingInput, setLoadingInput] = useState(false)

  const handleInputPlaca = (): string => {
    if (indiceCarreta === 1) {
      return placaCarreta1Input
    } else if (indiceCarreta === 2) {
      return placaCarreta2Input
    } else if (indiceCarreta === 3) {
      return placaCarreta3Input
    }
  }

  const debouncedPlaca = useDebounce(handleInputPlaca(), 1000)

  useEffect(() => {
    const init = async () => {
      if (debouncedPlaca && placaInput) {
        setLoadingInput(true)
        try {
          const response = await listVeiculos.execute({
            placa: placaInput,
            tipo: 'CARRETA',
            ativo: true,
          })
          setLoadingInput(false)

          let carretasDisponiveis = response?.data

          if (carreta1) {
            carretasDisponiveis = carretasDisponiveis.filter(
              item => item.id !== carreta1.id,
            )
          }

          if (carreta2) {
            carretasDisponiveis = carretasDisponiveis.filter(
              item => item.id !== carreta2.id,
            )
          }

          if (carreta3) {
            carretasDisponiveis = carretasDisponiveis.filter(
              item => item.id !== carreta3.id,
            )
          }

          setVeiculoList(carretasDisponiveis)
        } catch (e) {
          setLoadingInput(false)
        }
      } else {
        setVeiculoList([])
      }
    }

    init()
  }, [debouncedPlaca, listVeiculos, placaInput])

  const handleplaca = (placa: string) => {
    setPlacaInput(placa)
    if (indiceCarreta === 1) {
      setPlacaCarreta1Input(placa)
    } else if (indiceCarreta === 2) {
      setPlacaCarreta2Input(placa)
    } else if (indiceCarreta === 3) {
      setPlacaCarreta3Input(placa)
    }
  }

  const handleOnChange = (veiculo: Veiculo) => {
    if (indiceCarreta === 1) {
      setCarreta1(veiculo)
    } else if (indiceCarreta === 2) {
      setCarreta2(veiculo)
    } else if (indiceCarreta === 3) {
      setCarreta3(veiculo)
    }
  }

  useEffect(() => {
    let isValid = false
    if (indiceCarreta === 1 && carreta1) {
      isValid = true
    } else if (indiceCarreta === 2 && carreta2) {
      isValid = true
    } else if (indiceCarreta === 3 && carreta3) {
      isValid = true
    }
    setIsFormOk(isValid)
  }, [indiceCarreta, carreta1, carreta2, carreta3])

  // useEffect(() => {}, [loading])

  useEffect(() => {
    let isValid = false
    if (indiceCarreta === 1 && tipoCaminhao.quantidade_carretas === 1) {
      isValid = true
    } else if (indiceCarreta === 2 && tipoCaminhao.quantidade_carretas === 2) {
      isValid = true
    } else if (indiceCarreta === 3 && tipoCaminhao.quantidade_carretas === 3) {
      isValid = true
    }
    setIsTheEndOfCreate(isValid)
  }, [indiceCarreta])

  const handleNextButtonFn = async () => {
    registerEvent({
      categoria: 'Cadastro de Caminhão',
      acao: 'Click Próximo',
      local: 'Passo de selecionar a placa da carreta',
    })

    try {
      if (isTheEndOfCreate) {
        if (indiceCarreta === 1) {
          await handleCreateCaminhao(
            frotistaId,
            nomeCaminhao,
            tipoCaminhao?.id,
            veiculo?.id,
            carreta1?.id,
            null,
            null,
          )
        } else if (indiceCarreta === 2) {
          await handleCreateCaminhao(
            frotistaId,
            nomeCaminhao,
            tipoCaminhao?.id,
            veiculo?.id,
            carreta1?.id,
            carreta2?.id,
            null,
          )
        } else if (indiceCarreta === 3) {
          await handleCreateCaminhao(
            frotistaId,
            nomeCaminhao,
            tipoCaminhao?.id,
            veiculo?.id,
            carreta1?.id,
            carreta2?.id,
            carreta3?.id,
          )
        }
      } else {
        setIndiceCarreta(indiceCarreta + 1)
        setPlacaInput('')
        handleNextButton()
        setLoading(false)
      }
    } catch (e: unknown) {
      setLoading(false)
      if (e instanceof Error) {
        setErrorMessage(e.message)
      } else {
        setErrorMessage('Erro ao lidar com fluxo de cadastro do caminhão')
      }
      setError(true)
    }
  }

  return (
    <>
      <Scaffold
        onClickBackButton={handleBackButton}
        onClickNextButton={handleNextButtonFn}
        titleBackButton="Voltar"
        titleNextButton={isTheEndOfCreate ? 'Salvar' : 'Próximo'}
        isNextButtonDisabled={!isFormOk}
        showFooterScaffold
        icon={isTheEndOfCreate ? MdCheck : MdPlayArrow}
        color={isFormOk ? colors.green : colors.gray}
        title={`Placa da carreta ${indiceCarreta}`}
        titleHeader="Novo caminhão"
        loading={loading}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={3}>
            <Autocomplete
              label="Qual a placa da carreta?"
              placeholder=""
              onChange={(_event, newValue: Veiculo) => {
                handleOnChange(newValue)
              }}
              inputValue={placaInput}
              onInputChange={(_event, newInputValue) => {
                handleplaca(newInputValue)
              }}
              options={veiculosList}
              getOptionLabel={option => (option as Veiculo).placa}
              loading={loadingInput}
              popupIcon={MdSearch}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={9} />
          {indiceCarreta === 1 && carreta1 && (
            <>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Tipo da carreta</Text>
                <Text color={colors.grayDark} weight="bold">
                  {carreta1?.tipoCarreta?.descricao}
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Placa da carreta</Text>
                <Text color={colors.grayDark} weight="bold">
                  {carreta1?.placa}
                </Text>
              </Grid>
            </>
          )}
          {indiceCarreta === 2 && carreta2 && (
            <>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Tipo da carreta</Text>
                <Text color={colors.grayDark} weight="bold">
                  {carreta2?.tipoCarreta?.descricao}
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Placa da carreta</Text>
                <Text color={colors.grayDark} weight="bold">
                  {carreta2?.placa}
                </Text>
              </Grid>
            </>
          )}
          {indiceCarreta === 3 && carreta3 && (
            <>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Tipo da carreta</Text>
                <Text color={colors.grayDark} weight="bold">
                  {carreta3?.tipoCarreta?.descricao}
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Placa da carreta</Text>
                <Text color={colors.grayDark} weight="bold">
                  {carreta3?.placa}
                </Text>
              </Grid>
            </>
          )}
        </Grid>
        {frotistaId && (
          <Grid container style={{ marginTop: 100 }}>
            CNPJ Selecionado (Caminhão): <Value> {frotista?.cnpj} </Value>
          </Grid>
        )}
      </Scaffold>
    </>
  )
}

export default TruckPlate
